import React, { useState } from "react";

import { Popover } from "@mui/material";

import { RelationType } from "__generated__/graphql";
import { intl } from "LocaleWrapper";
import RelationSelect, { RelationSelectOption } from "view/relations/components/selects/RelationSelect";

import "../../declarations.scss";

const DebtorFilter = ({ onSelectDebtors } : {
	onSelectDebtors: (debtors: RelationSelectOption[]) => void;
}) => {

	const [ debtors, setDebtors ] = useState<RelationSelectOption[]>([]);
	const [ anchorEl, setAnchorEl ] = useState<HTMLSpanElement | null>(null);


	const open = Boolean(anchorEl);
	const id = open ? "debtors-filter-popover" : undefined;
	return (
		<React.Fragment>
			<span className={"debtors-filter"} >
				<span
					onClick={(event: React.MouseEvent<HTMLSpanElement>) =>
						setAnchorEl(event.currentTarget)
					}
				>
					{`${intl.formatMessage({ id: "ENTITY" })}: ${debtors?.length ? debtors.map(d => d.name).join(", ")
						: intl.formatMessage({ id: "NOT_SET" })}`}
				</span>

				<Popover
					id={id}
					open={open}
					anchorEl={anchorEl}
					onClose={() => setAnchorEl(null)}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "center",
					}}
					transformOrigin={{
						vertical: "top",
						horizontal: "center",
					}}>

					<div style={{ width: 300, padding: 16 }}>
						<RelationSelect
							multiple
							label={intl.formatMessage({ id: "ENTITY" })}
							types={[ RelationType.ApplicationRelation ]}
							value={debtors}
							onChange={(options) => {
								setDebtors(options ?? []);
								onSelectDebtors(options ?? []);
							}}
						/>
					</div>
				</Popover>
			</span>
		</React.Fragment>
	);
};

export default DebtorFilter;
